let permissionRequested = false;

export async function requestNotificationPermission(): Promise<boolean> {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  if (permissionRequested) return false;
  permissionRequested = true;
  const result = await Notification.requestPermission();
  return result === 'granted';
}

export function showChatNotification(sender: string, message: string): void {
  if (!('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  if (document.visibilityState === 'visible') return;

  try {
    new Notification(`AUTOKVEST: ${sender}`, {
      body: message.substring(0, 100),
      icon: '/app/icons/icon-192.png',
      tag: 'autoquest-chat',
    });
  } catch (_) { /* ignore */ }
}
